import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./slider.scss";

import styles from "./GeneralSlider.module.scss";
import ProductCard from "../../UI/ProductCard/ProductCard";
import { Link } from "react-router";

interface GeneralSliderProps {
  title: string;
  subtitle: string;
  slides: any;
}

const GeneralSlider: React.FC<GeneralSliderProps> = ({ title, subtitle, slides }) => {
  return (
    <section className={styles.generalSlider}>
      <div className="container">
        <div className={styles.body}>
          <h2 className={styles.choice}>{title}</h2>
          <p className={styles.all}>
            <Link to="/catalog">{subtitle}</Link>
          </p>
        </div>
        <Swiper
          spaceBetween={17}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: true,
          }}
          breakpoints={{
            993: {
              slidesPerView: 4,
            },
            668: {
              slidesPerView: 3,
            },
            0: {
              slidesPerView: 2,
            },
          }}
          navigation={true}
          modules={[Navigation, Autoplay]}
          className="mySwiper"
        >
          {slides.map((slide: any) => (
            <SwiperSlide key={slide.id}>
              <ProductCard img={slide.img} title={slide.title} price={slide.price} colors={slide.colors} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={styles.allGoods}>
          <button>Посмотреть все товары со скидками</button>
        </div>
      </div>
    </section>
  );
};

export default GeneralSlider;
